var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForgotpassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 710.935,
    height: 689.383,
    viewBox: "0 0 710.935 689.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M291.8,587.05l19.179-175.367L562.748,372.3,543.569,547.668Z",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(-124.132 -195.766)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3094350",
    "data-name": 3094350,
    transform: "translate(110.732 166.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(13.4 308.081)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_4_",
    cx: 355.468,
    cy: 205.194,
    rx: 355.468,
    ry: 205.194,
    fill: "#226bab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(35.089 336.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_43_",
    d: "M400.815,417.03c-37.287-13.428-37.287-35.305,0-48.733s98.06-13.428,135.347,0,37.287,35.305,0,48.733S438.1,430.458,400.815,417.03Z",
    transform: "translate(74.808 -227.874)",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_4_",
    d: "M91.634,482.842,30.378,447.386c-3.47-1.961-3.47-5.281,0-7.242L387.052,234.2a14.061,14.061,0,0,1,12.523,0l61.256,35.456c3.47,1.961,3.47,5.281,0,7.242L104.157,482.842A14.061,14.061,0,0,1,91.634,482.842Z",
    transform: "translate(-27.775 -232.725)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(80.541 29.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1341_",
    transform: "translate(147.709 340.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1346_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1347_",
    d: "M246.93,408.546l52.656-30.477c5.432-3.168,8.147-7.242,8.147-11.316V359.36l-54.618-30.779a11.674,11.674,0,0,1-5.281-9.053V254.5L155.8,307.76v65.028a11.674,11.674,0,0,0,5.281,9.053l46.47,26.856C218.414,414.883,236.067,414.883,246.93,408.546Z",
    transform: "translate(-155.8 -254.5)",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1608_",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1609_",
    d: "M246.93,408.546l52.656-30.477c5.432-3.168,8.147-7.242,8.147-11.316V359.36l-54.618-30.779a11.674,11.674,0,0,1-5.281-9.053V254.5L155.8,307.76v65.028a11.674,11.674,0,0,0,5.281,9.053l46.47,26.856C218.414,414.883,236.067,414.883,246.93,408.546Z",
    transform: "translate(-155.8 -254.5)",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1345_",
    d: "M177.979,369.7v7.242l-16.9-9.656a11.674,11.674,0,0,1-5.281-9.053V293.209L173.3,283.1c.3,4.526.754,9.053,1.056,13.579l-12.372,7.091v50.846a11.28,11.28,0,0,0,5.281,9.053Z",
    transform: "translate(-155.8 -239.949)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1344_",
    d: "M160,365.506a11.674,11.674,0,0,0,5.281,9.053l40.133,23.084c10.863,6.337,28.516,6.337,39.379,0L297.6,367.165c10.863-6.337,10.863-16.446,0-22.783L257.467,321.3a11.674,11.674,0,0,1-5.281-9.053V261.4l-92.035,53.26v50.846Z",
    transform: "translate(-153.663 -250.989)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1607_",
    d: "M160,365.506a11.674,11.674,0,0,0,5.281,9.053l40.133,23.084c10.863,6.337,28.516,6.337,39.379,0L297.6,367.165c10.863-6.337,10.863-16.446,0-22.783L257.467,321.3a11.674,11.674,0,0,1-5.281-9.053V261.4l-92.035,53.26v50.846Z",
    transform: "translate(-153.663 -250.989)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1343_",
    d: "M268.028,327.584h0L257.316,321.4a11.674,11.674,0,0,1-5.281-9.053V261.5L160,314.76v50.846a11.674,11.674,0,0,0,5.281,9.053l10.561,6.035Z",
    transform: "translate(-153.663 -250.939)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1342_",
    d: "M283.313,324.1v7.393c0,4.074-2.716,8.147-8.147,11.316l-52.656,30.477c-5.281,3.018-11.919,4.526-18.709,4.677v-7.242c6.789-.151,13.579-1.66,18.709-4.677l52.656-30.477C280.6,332.247,283.313,328.174,283.313,324.1Z",
    transform: "translate(-131.379 -219.089)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1610_",
    d: "M283.313,324.1v7.393c0,4.074-2.716,8.147-8.147,11.316l-52.656,30.477c-5.281,3.018-11.919,4.526-18.709,4.677v-7.242c6.789-.151,13.579-1.66,18.709-4.677l52.656-30.477C280.6,332.247,283.313,328.174,283.313,324.1Z",
    transform: "translate(-131.379 -219.089)",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1340_",
    d: "M64.086,546.92c3.47,1.961,9.053,1.811,12.674-.3,45.263-26.1,310.808-179.393,356.071-205.5a14.547,14.547,0,0,0,6.488-11.316V41.631c0-4.225-2.716-9.2-6.186-11.165s-9.053-1.811-12.674.3L64.388,236.414A14.547,14.547,0,0,0,57.9,247.73V535.755C58.051,539.979,60.767,544.958,64.086,546.92Z",
    transform: "translate(-57.9 -29.084)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1339_",
    d: "M72.69,543.968l356.071-205.5a14.547,14.547,0,0,0,6.488-11.316V38.981c0-4.225-2.867-5.884-6.488-3.772L72.69,240.855A14.547,14.547,0,0,0,66.2,252.171V540.2C66.051,544.421,69.069,546.08,72.69,543.968Z",
    transform: "translate(-53.679 -26.434)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1338_",
    d: "M72.69,543.968l356.071-205.5a14.547,14.547,0,0,0,6.488-11.316V38.981c0-4.225-2.867-5.884-6.488-3.772L72.69,240.855A14.547,14.547,0,0,0,66.2,252.171V540.2C66.051,544.421,69.069,546.08,72.69,543.968Z",
    transform: "translate(-53.679 -26.434)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1337_",
    d: "M75.854,389.819a13.918,13.918,0,0,1-11.768-.3c-3.319-1.961-6.186-6.94-6.186-11.165V352.1l12.372,7.091v26.253C70.272,389.367,72.686,391.026,75.854,389.819Z",
    transform: "translate(-57.9 135.258)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1606_",
    d: "M75.854,389.819a13.918,13.918,0,0,1-11.768-.3c-3.319-1.961-6.186-6.94-6.186-11.165V352.1l12.372,7.091v26.253C70.272,389.367,72.686,391.026,75.854,389.819Z",
    transform: "translate(-57.9 135.258)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1336_",
    d: "M66.1,428.639v26.253c0,4.225,2.867,5.884,6.488,3.772l356.071-205.5a14.547,14.547,0,0,0,6.488-11.316V215.6Z",
    transform: "translate(-53.728 65.81)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1335_",
    d: "M66.1,428.639v26.253c0,4.225,2.867,5.884,6.488,3.772l356.071-205.5a14.547,14.547,0,0,0,6.488-11.316V215.6Z",
    transform: "translate(-53.728 65.81)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1334_",
    d: "M74.3,481.2V249.3a8.64,8.64,0,0,1,3.923-6.789L414.831,48.178c2.112-1.207,3.923-.3,3.923,2.263v231.9a8.64,8.64,0,0,1-3.923,6.789L78.223,483.46C75.96,484.818,74.3,483.762,74.3,481.2Z",
    transform: "translate(-49.556 -19.639)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1333_",
    d: "M74.3,481.2V249.3a8.64,8.64,0,0,1,3.923-6.789L414.831,48.178c2.112-1.207,3.923-.3,3.923,2.263v231.9a8.64,8.64,0,0,1-3.923,6.789L78.223,483.46C75.96,484.818,74.3,483.762,74.3,481.2Z",
    transform: "translate(-49.556 -19.639)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1332_",
    d: "M190.586,291.979a13.544,13.544,0,0,0-6.186,10.712c0,3.923,2.716,5.583,6.186,3.621a13.544,13.544,0,0,0,6.186-10.712C196.621,291.677,193.905,290.017,190.586,291.979Z",
    transform: "translate(6.46 104.25)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1331_",
    d: "M72.233,176.791a13.451,13.451,0,0,0-1.961,6.488V452.143L57.9,445.052l.151-268.864a13.451,13.451,0,0,1,1.961-6.488Z",
    transform: "translate(-57.9 42.457)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1544_",
    d: "M438.808,40.524c-.453-3.319-3.168-4.677-6.488-2.716L76.249,243.454a14.355,14.355,0,0,0-4.677,4.828L59.2,241.191a14.355,14.355,0,0,1,4.677-4.828l356.071-205.5c3.621-2.112,9.354-2.263,12.674-.3C435.79,32.225,438.355,36.6,438.808,40.524Z",
    transform: "translate(-57.239 -29.033)",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Window_1_",
    transform: "translate(137.271 75.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1920_",
    transform: "translate(0.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M439.45,60.3a3.363,3.363,0,0,0-3.319.3l-336,193.878a10.017,10.017,0,0,0-4.526,8V492.87a4.234,4.234,0,0,0,1.961,3.923c.754.453,4.677,2.716,5.884,3.319a2.551,2.551,0,0,0,2.716-.151l336-194.029a10.017,10.017,0,0,0,4.526-8V66.49a3.4,3.4,0,0,0-1.358-3.018C444.278,63.02,440.355,60.757,439.45,60.3Z",
    transform: "translate(-95.6 -59.995)",
    fill: "#226bab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1917_",
    transform: "translate(0 3.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1919_",
    transform: "translate(6.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M102.263,498.434c-1.358,0-2.263-1.509-2.263-3.47V264.423a9.138,9.138,0,0,1,4.225-7.242L440.078,63.153a3.934,3.934,0,0,1,1.66-.453c1.056,0,1.811.905,1.811,2.565v231.6a9.138,9.138,0,0,1-4.225,7.242l-336,194.029A2.8,2.8,0,0,1,102.263,498.434Z",
    transform: "translate(-99.246 -61.946)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M441.992,63.709h0c.905,0,1.056,1.056,1.056,1.811v231.6a8.874,8.874,0,0,1-3.772,6.639l-336,193.878a2.549,2.549,0,0,1-.754.3c-.905,0-1.509-1.358-1.509-2.716V264.678a8.874,8.874,0,0,1,3.772-6.639l336-194.029a2.592,2.592,0,0,1,1.207-.3m0-1.509a4.126,4.126,0,0,0-2.112.6L104.026,256.832a10.017,10.017,0,0,0-4.526,8v230.39c0,2.263,1.358,4.225,3.018,4.225a2.912,2.912,0,0,0,1.509-.453l336-194.029a10.017,10.017,0,0,0,4.526-8V65.368c0-2.112-1.056-3.168-2.565-3.168Z",
    transform: "translate(-99.5 -62.2)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1918_",
    d: "M97.461,423.627c.453.3,4.074,2.263,5.582,3.168a4.591,4.591,0,0,1-1.66-3.923V207.57L95.5,204.1V419.553C95.5,421.364,96.254,423.023,97.461,423.627Z",
    transform: "translate(-95.5 9.995)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1913_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1916_",
    d: "M444.557,65.385c0-2.867-2.112-4.074-4.526-2.565l-336,194.029a10.017,10.017,0,0,0-4.526,8v15.088L444.557,80.473Z",
    transform: "translate(-93.465 -58.89)",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1915_",
    transform: "translate(1.509)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M441.557,63.925l-336,194.029a8.876,8.876,0,0,0-3.168,3.47L96.5,258.1a8.422,8.422,0,0,1,3.168-3.319l336-194.179a3.363,3.363,0,0,1,3.319-.3c.754.453,4.677,2.716,5.583,3.168C443.82,63.02,442.764,63.171,441.557,63.925Z",
    transform: "translate(-96.5 -59.995)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1914_",
    d: "M95.5,210.663V195.726a9.861,9.861,0,0,1,1.358-4.526l5.884,3.319a8.733,8.733,0,0,0-1.358,4.526v15.088Z",
    transform: "translate(-95.5 6.759)",
    opacity: 0.15
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_979_",
    transform: "translate(145.218 149.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1560_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1570_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2351_",
    d: "M241.776,157.326c-4.979-2.867-11.919-2.565-19.614,1.961-15.239,8.9-27.761,30.326-27.761,47.979,0,8.9,3.168,15.088,8.147,17.954,1.358.754,8.449,4.828,9.807,5.733,4.979,2.867,11.919,2.414,19.614-1.961,15.239-8.9,27.761-30.326,27.761-47.979,0-8.9-3.168-15.088-8.147-17.954",
    transform: "translate(-194.4 -155.469)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2399_",
    d: "M228.661,163.094C213.423,172,200.9,193.421,200.9,211.073s12.372,24.895,27.761,15.993c15.239-8.9,27.761-30.326,27.761-47.979C256.423,161.284,243.9,154.193,228.661,163.094Z",
    transform: "translate(-191.093 -153.543)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1014_",
    d: "M240.4,157.311l9.807,5.733c-4.979-2.867-11.919-2.565-19.614,1.961-9.958,5.733-18.86,17.049-23.688,28.969l-9.807-5.733c4.828-12.07,13.579-23.235,23.688-28.969C228.483,154.9,235.423,154.444,240.4,157.311Z",
    transform: "translate(-193.026 -155.454)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1016_",
    d: "M212,213.186c-1.66-1.056-8.147-4.828-9.354-5.432-4.979-2.867-8.147-9.053-8.147-17.954l9.807,5.733C204.307,204.133,207.174,210.168,212,213.186Z",
    transform: "translate(-194.349 -138.002)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_995_",
    d: "M198.474,177.2l9.807,5.733a51.31,51.31,0,0,0-4.074,19.011h0l-9.807-5.733A54.505,54.505,0,0,1,198.474,177.2Z",
    transform: "translate(-194.4 -144.413)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(-395.443 -339.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M420,383.022V399.67a3.372,3.372,0,0,0,5.02,2.943L445.048,391.4a4.687,4.687,0,0,0,2.4-4.089V371.244a4.265,4.265,0,0,0-6.46-3.658L422.44,378.712A5.028,5.028,0,0,0,420,383.022Z",
    transform: "translate(0 0.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M426,380.9V368.42a6.945,6.945,0,0,1,3.445-6l3.877-2.261a4.177,4.177,0,0,1,6.274,3.347l.675,10.8-3.293,1.1-.833-8.334a1.831,1.831,0,0,0-2.64-1.456l-1.59.795a4.741,4.741,0,0,0-2.621,4.241V379.8Z",
    transform: "translate(0.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1.647,
    cy: 2.744,
    rx: 1.647,
    ry: 2.744,
    transform: "translate(433.271 383.094)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M434,385.1v3.293l2.2-1.1L435.1,384Z",
    transform: "translate(0.369 2.387)",
    fill: "#474a4e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds",
    transform: "translate(535.805 48.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clouds_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1526_",
    d: "M379.237,85.763l4.828,1.811V77.012c0-8.449,6.639-10.411,13.881-6.186h0c7.242,4.225,13.126,14.333,13.126,22.783v1.509a6.985,6.985,0,0,1,6.035.905h0c5.281,3.018,9.505,10.411,9.505,16.446v.754l6.639,3.923a13.589,13.589,0,0,1,6.186,10.863c0,3.923-2.716,5.582-6.186,3.621L379.086,100.4A13.589,13.589,0,0,1,372.9,89.534C373.051,85.461,375.767,83.8,379.237,85.763Z",
    transform: "translate(-372.9 -68.674)",
    fill: "#e6e6e6",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1523_",
    d: "M420.975,76.134l8.751,4.979V77.341c0-4.526,3.168-6.337,7.091-4.074a15.375,15.375,0,0,1,4.225,4.074c.6-5.582,5.13-7.695,10.411-4.677,5.884,3.319,10.561,11.467,10.561,18.256v3.772a9.407,9.407,0,0,1-.905,4.375l7.242,4.225a8.64,8.64,0,0,1,3.923,6.789c0,2.414-1.811,3.47-3.923,2.263L421.126,85.036a8.64,8.64,0,0,1-3.923-6.789C417.052,75.833,418.863,74.777,420.975,76.134Z",
    transform: "translate(-350.364 -67.344)",
    fill: "#e6e6e6",
    opacity: 0.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(4.201 39.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M327.282,553.9l-1.159-38.815L354,499.9l1.154,38.817L327.282,553.9m34.67-18.892-1.16-38.815,27.878-15.192,1.155,38.817-27.873,15.19m34.669-18.892-1.16-38.815,27.879-15.192,1.154,38.817-27.873,15.19m34.669-18.892-1.154-38.816,27.873-15.191,1.159,38.816L431.29,497.228m34.669-18.892L464.8,439.52l27.873-15.191,1.16,38.816-27.879,15.191m34.67-18.892-1.155-38.816,27.878-15.191,1.155,38.816-27.878,15.191m49.062-82.222a1.948,1.948,0,0,0-.639.227L303.474,511.27a4.8,4.8,0,0,0-2.121,4.051l1.931,64.924c.039,1.292.737,2.016,1.659,1.871a1.977,1.977,0,0,0,.635-.223L551.155,448.072a4.806,4.806,0,0,0,2.122-4.051L551.346,379.1c-.04-1.29-.735-2.019-1.655-1.875",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M304.943,582.116c-.922.145-1.62-.579-1.659-1.871l-1.931-64.924a4.8,4.8,0,0,1,2.121-4.051L549.052,377.449a1.948,1.948,0,0,1,.639-.227c.92-.144,1.615.585,1.655,1.875l1.931,64.924a4.806,4.806,0,0,1-2.122,4.051L305.578,581.893a1.977,1.977,0,0,1-.635.223M550,374.3a3.2,3.2,0,0,0-1.028.363L303.389,508.48c-2.168,1.178-3.857,4.669-3.766,7.778l1.936,64.923c.075,2.609,1.377,4.127,3.074,3.862a3.119,3.119,0,0,0,1.026-.36L551.241,450.862c2.168-1.179,3.858-4.678,3.767-7.787l-1.936-64.923c-.076-2.6-1.379-4.121-3.073-3.856",
    fill: "#b5d9f6",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M340.136,526.141l-.3-4.157,1.726-.936-.044,4.427,2.628-2.954.583,1.95L341.94,527.1l1.945,2.23-1.356,2.141-1.715-2.681-1.482,4.3-1.442-.553,1.808-4.348-2.8.421.453-2.493,2.786.031M352.9,502.388l-25.571,13.93,1.045,35.1,25.571-13.931-1.045-35.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M328.376,551.415l-1.045-35.1,25.571-13.93,1.045,35.1-25.571,13.931M354,499.9l-27.878,15.192,1.159,38.815,27.873-15.19L354,499.9",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M374.8,506.749l-.307-4.157,1.731-.936-.049,4.428,2.627-2.954.589,1.949L376.6,507.7l1.949,2.238-1.361,2.142-1.71-2.682-1.487,4.3-1.438-.554,1.8-4.356-2.8.429.453-2.493,2.792.031M387.571,483.5,362,497.426l1.045,35.1,25.572-13.931-1.046-35.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M363.045,532.523,362,497.426l25.571-13.93,1.046,35.1-25.572,13.931m25.625-51.518L360.792,496.2l1.16,38.815,27.873-15.19-1.155-38.817",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M407.078,494.061l-.085-2.842,4.964-2.7.085,2.841-4.964,2.706M422.246,464.6l-25.577,13.931,1.046,35.1L423.291,499.7l-1.045-35.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M397.715,513.631l-1.046-35.1L422.246,464.6l1.045,35.1-25.576,13.932m25.625-51.518L395.461,477.3l1.16,38.815,27.873-15.19-1.154-38.817",
    fill: "#ddedfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M441.747,475.169l-.085-2.842,4.964-2.7.085,2.841-4.964,2.706m15.168-29.458-25.576,13.932,1.045,35.1,25.576-13.932-1.045-35.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M432.384,494.739l-1.045-35.1,25.576-13.932,1.045,35.1-25.576,13.932m25.625-51.518-27.873,15.191,1.154,38.816,27.878-15.191-1.159-38.816",
    fill: "#ddedfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M476.416,456.277l-.085-2.842,4.965-2.7.085,2.841-4.965,2.706m15.168-29.458L466.013,440.75l1.045,35.1,25.572-13.931-1.046-35.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M467.058,475.846l-1.045-35.1,25.571-13.931,1.046,35.1-25.572,13.931m25.62-51.517L464.8,439.52l1.154,38.816,27.879-15.191-1.16-38.816",
    fill: "#ddedfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M511.086,437.385,511,434.543l4.964-2.7.085,2.841-4.964,2.706m15.168-29.458-25.572,13.931,1.046,35.1L527.3,443.015l-1.046-35.088",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M501.728,456.954l-1.046-35.1,25.572-13.931,1.046,35.088-25.572,13.939m25.624-51.517-27.878,15.191,1.155,38.816,27.878-15.191-1.155-38.816",
    fill: "#ddedfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M341.56,521.048l-1.725.936.3,4.157-2.787-.031L336.9,528.6l2.8-.421-1.808,4.349,1.442.553,1.482-4.3,1.715,2.682,1.356-2.141-1.945-2.23,2.786-2.624-.583-1.95-2.627,2.954.043-4.427",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M376.219,501.656l-1.73.937.307,4.156-2.792-.03-.453,2.493,2.8-.43-1.8,4.357,1.437.554,1.487-4.3,1.71,2.682,1.361-2.142-1.949-2.238,2.791-2.616-.588-1.95-2.627,2.954.048-4.428",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M411.957,488.514l-4.964,2.706.085,2.841,4.964-2.706-.085-2.841",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M446.626,469.622l-4.964,2.706.085,2.841,4.964-2.706-.085-2.841",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M481.3,450.73l-4.964,2.706.085,2.841,4.964-2.706-.085-2.841",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M515.965,431.838,511,434.543l.085,2.841,4.964-2.706-.085-2.841",
    fill: "#226bab"
  })))))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(218.648 -382.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(361.332 644.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(103.567)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 10.783,
    cy: 10.783,
    r: 10.783,
    transform: "translate(20.91 105.998) rotate(-10.614)",
    fill: "#226bab",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 6.114,
    cy: 6.073,
    rx: 6.114,
    ry: 6.073,
    transform: "translate(16.628 130.904) rotate(-10.614)",
    fill: "#226bab",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 42.552,
    cy: 42.552,
    r: 42.552,
    transform: "translate(0 60.178) rotate(-45)",
    fill: "#226bab",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(38.454 54.814)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 5.371,
    cy: 5.371,
    r: 5.371,
    transform: "translate(32.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 5.371,
    cy: 5.371,
    r: 5.371,
    transform: "translate(16.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 5.371,
    cy: 5.371,
    r: 5.371,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 153.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(0 169.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(125.413 69.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M733.686,1609.41l-3.966,15.327a8.776,8.776,0,0,1-9.171,6.4c-13.014-.868-40.115-4.09-55.649-15.534l4.421-22.1c21.359-1.2,41.354,0,58.664,5.825A8.441,8.441,0,0,1,733.686,1609.41Z",
    transform: "translate(-664.9 -1593.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M770.466,1633.489a.579.579,0,0,0,.5-.372l5.329-19.128a.511.511,0,1,0-.992-.248l-5.329,19.128a.474.474,0,0,0,.372.62Z",
    transform: "translate(-726.55 -1604.977)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M742.466,1627.289a.579.579,0,0,0,.5-.372l5.329-19.128a.511.511,0,0,0-.992-.248l-5.329,19.128a.474.474,0,0,0,.372.62Z",
    transform: "translate(-710.117 -1601.338)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M550,1427.64l49.658,14.749L562.8,1492.914l-52.963,4.214L436.8,1466.267l27.762-41.767Z",
    transform: "translate(-405.622 -1424.5)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M444.482,1439.785C335.416,1407.52,317.9,1503.9,488.067,1521.42c5.99-6.775,13.014-18.508,15.823-28.3l-89.856-41.52Z",
    transform: "translate(-361.332 -1429.622)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M551.11,1609.375a48.7,48.7,0,0,0,10-4.875l17.517,5.495-4.007,19.087L556.4,1632.8C550.862,1622.636,550.531,1614.333,551.11,1609.375Z",
    transform: "translate(-472.587 -1530.137)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M553.266,1514.405l.785-1.322c-18.756-10.907-66.762-37.058-107.662-44.783l-.289,1.529C486.752,1477.471,534.551,1503.54,553.266,1514.405Z",
    transform: "translate(-411.08 -1450.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M631.455,1428.529c101.506-19.293,127.781,78.247-42.346,95.8a61.787,61.787,0,0,1-13.509-24.581,776.932,776.932,0,0,1,87.377-49.947Z",
    transform: "translate(-487.08 -1425.389)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M575.426,1522.16c4.834-3.057,9.874-6.321,15.2-9.75,26.729-17.269,57.053-36.851,82.791-48.006l-.62-1.4c-25.862,11.2-56.227,30.819-83.039,48.13q-7.994,5.143-15.162,9.75Z",
    transform: "translate(-486.493 -1447.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M866.686,1528.483l1.363-.744c-3.8-6.9-9.915-11.568-18.136-13.84l-.413,1.487C857.391,1517.618,863.051,1521.873,866.686,1528.483Z",
    transform: "translate(-647.823 -1476.966)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M376.363,1514.283c3.636-6.61,9.3-10.907,17.186-13.1l-.413-1.487c-8.221,2.272-14.336,6.941-18.136,13.84Z",
    transform: "translate(-369.353 -1468.633)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M609.058,1620.626l1.115-1.074c-8.139-8.717-13.1-17.889-15.244-28.052l-1.529.331C595.631,1602.283,600.754,1611.7,609.058,1620.626Z",
    transform: "translate(-497.526 -1522.507)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(20.451 71.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M418.3,1599.071c13.014-8.015,38.214,5.866,44.535,6.569a15.353,15.353,0,0,0,6.073-.868c-.578,4.916-.248,13.261,5.288,23.383l-3.1.62s-21.4,7.849-44.081,3.264C406.111,1627.825,408.052,1605.392,418.3,1599.071Z",
    transform: "translate(-410.835 -1596.587)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M469.445,1634.251a.249.249,0,0,0,.165-.041.508.508,0,0,0,.331-.661c-1.529-4.875-2.231-14.5,2.272-20.987a.5.5,0,1,0-.826-.578c-4.668,6.775-4.007,16.814-2.4,21.9A.417.417,0,0,0,469.445,1634.251Z",
    transform: "translate(-444.259 -1605.491)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M494.145,1638.951a.248.248,0,0,0,.165-.041.508.508,0,0,0,.331-.661c-1.529-4.875-2.231-14.5,2.272-20.987a.5.5,0,0,0-.826-.578c-4.668,6.775-4.007,16.814-2.4,21.9C493.691,1638.827,493.9,1638.951,494.145,1638.951Z",
    transform: "translate(-458.754 -1608.25)",
    fill: "#fff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(7.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(128.486 0.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M716.887,1062.853s-25.573-21.731-24.622-25.862c.661-2.933,7.932,1.363,7.932,1.363s-10.163-12.063-9.626-13.509c.909-2.6,7.932,2.272,7.932,2.272s-4.751-6.817-2.479-7.932,7.23,3.1,7.23,3.1-2.892-3.8-1.529-4.792,7.23,3.1,7.23,3.1-2.107-4.792,2.355-2.975,35.777,30.572,35.777,30.572Z",
    transform: "translate(-690.55 -1017.204)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(7.462 2.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M728.185,1054.466a.469.469,0,0,0,.331-.124c4.379-4.007,6.321-5,11.154-6.486a.523.523,0,0,0-.331-.992c-5,1.529-7.023,2.562-11.568,6.693a.568.568,0,0,0-.041.744A1.016,1.016,0,0,0,728.185,1054.466Z",
    transform: "translate(-719.762 -1037.419)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M734.418,1082.392h.083a.514.514,0,0,0,.454-.578c-.5-3.594-1.653-5.825-3.47-6.858-1.57-.867-3.594-.785-6.032.248a.51.51,0,0,0,.372.95c2.148-.909,3.842-1.033,5.123-.331,1.487.826,2.479,2.892,2.933,6.114A.564.564,0,0,0,734.418,1082.392Z",
    transform: "translate(-718.31 -1053.571)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M740.6,1031.127a.448.448,0,0,0,.372-.165.492.492,0,0,0-.041-.744l-6.4-6.032a.527.527,0,0,0-.7.785l6.4,6.032A.665.665,0,0,0,740.6,1031.127Z",
    transform: "translate(-723.298 -1024.036)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M726.707,1035.651a.667.667,0,0,0,.372-.124.524.524,0,0,0,0-.744l-6.156-6.4a.526.526,0,0,0-.744.744l6.156,6.4A.5.5,0,0,0,726.707,1035.651Z",
    transform: "translate(-715.31 -1026.495)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M713.936,1046.145a.666.666,0,0,0,.372-.124.567.567,0,0,0,.041-.744l-4.834-5.205a.527.527,0,1,0-.785.7l4.834,5.205A.524.524,0,0,0,713.936,1046.145Z",
    transform: "translate(-708.611 -1033.353)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(0 26.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M507.067,1304.536l93.491,3.636,10.328-85.229s-31.274-29.663-43.337-40.611l-20.326-1.033C484.18,1209.971,494.508,1245.748,507.067,1304.536Z",
    transform: "translate(-448.834 -1138.748)",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M477.933,1181.3s-72.132,6.156-94.9,55.607c-22.268,48.377,69.2,65.6,69.2,65.6Z",
    transform: "translate(-379.544 -1138.748)",
    fill: "#226bab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M725.983,1131.47,696.155,1095.2l27.886-16.9c11.609,8.1,34.124,26.4,53.17,47.138a39.172,39.172,0,0,1,9.13,15.823,34.244,34.244,0,0,1,.868,14.831h0a28.651,28.651,0,0,1-25.325,24c-11.361,1.322-54.74-2.066-89.856-12.394L661.7,1127.834C667.029,1124.818,706.483,1124.281,725.983,1131.47Z",
    transform: "translate(-545.133 -1078.3)",
    fill: "#226bab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0.726 38.189)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M471.354,1208.553c-.165-.041-.331-.083-.454-.124.33-.207.661-.372.991-.578a153.876,153.876,0,0,0,16.112,3.1c3.222.372,14.046,1.115,17.186-6.073,1.57-3.594.372-7.56-1.4-10.37a4.351,4.351,0,0,1,.785-.207c1.818,2.974,2.975,7.106,1.322,10.865-3.388,7.684-14.625,6.941-17.971,6.569A158.461,158.461,0,0,1,471.354,1208.553Z",
    transform: "translate(-433.884 -1158.358)",
    fill: "#074377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M385.1,1360.269c3.429-1.322,7.023-2.727,10.741-2.355,6.569.62,12.187,7.106,12.518,14.46.248,5-1.694,10.287-5.329,14.914-.207-.124-.454-.289-.661-.413,3.553-4.5,5.453-9.584,5.205-14.459-.331-6.982-5.619-13.137-11.815-13.757-3.553-.331-6.9.95-10.411,2.313-1.239.5-2.52.992-3.842,1.4-.083-.248-.124-.5-.207-.744C382.622,1361.219,383.861,1360.764,385.1,1360.269Z",
    transform: "translate(-381.3 -1254.342)",
    fill: "#074377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M824.334,1298.8c4.5-3.718,11.485-4.71,19.21-2.727a33.042,33.042,0,0,1,16.773,9.956c-.248.083-.537.165-.785.248a32.565,32.565,0,0,0-16.195-9.461c-7.436-1.942-14.212-.992-18.508,2.561a16.277,16.277,0,0,0-4.544,6.28c-.248-.041-.537-.041-.785-.083A17.483,17.483,0,0,1,824.334,1298.8Z",
    transform: "translate(-638.467 -1217.501)",
    fill: "#074377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M879.717,1137.376a93.215,93.215,0,0,1-24.251-9.419c-2.851-1.653-6.114-3.76-8.387-6.858a11.759,11.759,0,0,1-2.148-10.493,7.966,7.966,0,0,1,2.107-3.305,7.2,7.2,0,0,1,.578.5,7.193,7.193,0,0,0-1.942,3.057,11.048,11.048,0,0,0,2.024,9.791c2.19,2.974,5.371,5.04,8.139,6.651a91.17,91.17,0,0,0,22.887,9.047C879.056,1136.673,879.386,1137,879.717,1137.376Z",
    transform: "translate(-653.116 -1107.3)",
    fill: "#074377"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(77.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M601.7,1133.563v1.322l.207,20.532.041,2.231a12.787,12.787,0,0,0,25.573-.041l.248-25.407Z",
    transform: "translate(-587.663 -1083.724)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M601.8,1138.7l.207,20.532c11.4-4.668,16.112-17.021,16.112-17.021Z",
    transform: "translate(-587.721 -1087.538)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M577.725,1049.376c-4.09,4.916-16.029,32.72-3.925,42.222,13.633,10.7,34.372-6.858,34.372-6.858l2.768-32.389-18.012-4.751Z",
    transform: "translate(-568.191 -1034.074)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M660.4,1047.6s39.95,20.822,7.354,80.849a16.325,16.325,0,0,1-21.359,7.312h0a16.2,16.2,0,0,1-7.106-22.64c5.329-9.461,10.452-21.648,8.263-30.7Z",
    transform: "translate(-608.483 -1034.074)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 10.783,
    cy: 10.783,
    r: 10.783,
    transform: "translate(32.903 23.366) rotate(-45)",
    fill: "#111516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M602.622,1051.191c1.157-6.734,1.859-11.361-4.916-14.831,0,0-24,4.379-28.589-4.71-4.586-9.048,2.4-23.342,17.021-13.427,37.43-7.312,42.428,27.721,31.109,39.413l-11.2-1.735A4.008,4.008,0,0,1,602.622,1051.191Z",
    transform: "translate(-567.722 -1014.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(3.874 24.057)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1.611,
    cy: 1.611,
    r: 1.611,
    transform: "translate(10.824 10.703)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.611,
    cy: 1.611,
    r: 1.611,
    transform: "translate(0 5.374)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M581.308,1104.343a.549.549,0,0,0,.331-.124.414.414,0,0,0,0-.62c-.62-.661-1.322-1.611-1.033-2.313s1.611-1.033,2.19-1.033c1.281,0,1.9-2.272,1.983-2.727a.446.446,0,0,0-.868-.207c-.248.95-.744,2.024-1.115,2.024-.62,0-2.479.289-3.016,1.57-.413.909,0,2.024,1.239,3.305A.322.322,0,0,0,581.308,1104.343Z",
    transform: "translate(-578.582 -1087.112)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M582.873,1126.544a.588.588,0,0,0,.248-.083,6.132,6.132,0,0,1,6.073-.331.453.453,0,1,0,.454-.785,6.91,6.91,0,0,0-7.023.331.455.455,0,0,0-.124.62A.345.345,0,0,0,582.873,1126.544Z",
    transform: "translate(-580.229 -1103.281)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M608.523,1085.148c-.909,1.694.661,2.066,2.52,3.057s3.759,1.363,4.173.537-.7-2.272-2.561-3.264S609.225,1083.826,608.523,1085.148Z",
    transform: "translate(-595.385 -1079.733)",
    fill: "#111516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M583.971,1075.409c-.413,1.529-1.529.868-3.181.413s-2.975-1.281-2.809-1.983c.207-.744,1.694-.95,3.346-.537C582.979,1073.756,584.26,1074.211,583.971,1075.409Z",
    transform: "translate(-577.608 -1073.092)",
    fill: "#111516"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 4.71,
    cy: 4.71,
    r: 4.71,
    transform: "translate(17.015 44.085) rotate(-47.314)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 7.23,
    cy: 6.362,
    rx: 7.23,
    ry: 6.362,
    transform: "matrix(0.792, -0.611, 0.611, 0.792, 31.902, 43.26)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M660.854,1119.2a.458.458,0,0,0,.454-.454,4.036,4.036,0,0,1,1.735-3.305,3.242,3.242,0,0,1,2.974-.413.445.445,0,0,0,.331-.826,3.966,3.966,0,0,0-3.8.5,4.9,4.9,0,0,0-2.148,4.049A.458.458,0,0,0,660.854,1119.2Z",
    transform: "translate(-622.112 -1072.998)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(31.999 79.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 1.033,
    height: 24.003,
    transform: "translate(148.457 0.701) rotate(-42.751)",
    fill: "#074377",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M491.372,1358.378l.289-.991c-11.857-3.636-23.383-7.932-33.835-20.987l-.826.661C467.659,1350.322,479.309,1354.7,491.372,1358.378Z",
    transform: "translate(-457 -1282.57)",
    fill: "#074377",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(60.097 114.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M513.369,1292.8H614.338a6.848,6.848,0,0,1,6.569,7.106V1372a6.848,6.848,0,0,1-6.569,7.106H513.369A6.848,6.848,0,0,1,506.8,1372v-72.091A6.848,6.848,0,0,1,513.369,1292.8Z",
    transform: "translate(-506.8 -1292.8)",
    fill: "#d3dfff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(48.956 36.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M628.068,1383.266h10.659a.733.733,0,0,1,.7.744v7.6a.733.733,0,0,1-.7.744H628.068a.733.733,0,0,1-.7-.744v-7.6a.733.733,0,0,1,.7-.744m0-2.066a2.8,2.8,0,0,0-2.768,2.809v7.6a2.777,2.777,0,0,0,2.768,2.809h10.659a2.8,2.8,0,0,0,2.768-2.809v-7.6a2.777,2.777,0,0,0-2.768-2.809Z",
    transform: "translate(-625.3 -1381.2)",
    fill: "#37474f"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotpassword);
export default __webpack_public_path__ + "static/media/forgotpassword.d494a2bedf8eef8866b7e7e8f5164fe1.svg";
export { ForwardRef as ReactComponent };